import {
  SegmentDivider as DishFirstSegmentDivider,
  SegmentDividerContainer as DishFirstSegmentDividerContainer,
} from 'src/pages/consumer/dish-first/explore/styles';
import styled from 'styled-components';
import { Mixins, Spacing } from 'web-common/src/shared/styles';

const PADDING = 16;
const SHADOW_BREATHING_ROOM = 36;

export const DishFirstComponentWrapperForShefMenu = styled.div`
  margin: 0 -15px;
`;

export const ShefMenuSegmentRowContainer = styled(DishFirstComponentWrapperForShefMenu)`
  margin-bottom: ${Spacing.DOUBLE};
`;

export const BrowseByMealTypeSection = styled(DishFirstComponentWrapperForShefMenu)`
  padding-bottom: ${Spacing.SINGLE};
  &:empty {
    display: none;
    padding-bottom: 0;
  }
`;

export const SegmentRowContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 15px;

  ${Mixins.Media.maxWidthSmall(`
    padding: 0;
  `)}
`;

export const SegmentRow = styled.div`
  width: 100%;

  ${Mixins.Media.minWidthMedium(`
    width: calc(100% + ${SHADOW_BREATHING_ROOM * 2}px);
    margin-right: -${SHADOW_BREATHING_ROOM}px;
    margin-left: -${SHADOW_BREATHING_ROOM}px;
  `)}

  display: flex;
  align-items: center;
  justify-content: flex-start;

  overflow-x: scroll;
  overflow-y: clip;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  scroll-snap-type: x mandatory;
  scroll-padding-left: ${SHADOW_BREATHING_ROOM}px;

  & > * {
    scroll-snap-align: start;
  }

  ${Mixins.Media.maxWidthMedium(`
    scroll-padding-left: ${SHADOW_BREATHING_ROOM}px;
    margin-left: -${SHADOW_BREATHING_ROOM / 2}px;
  `)}
  ${Mixins.Media.maxWidthSmall(`
    scroll-snap-type: none;
    margin-left: 0;
  `)}

  // Give box shadows breathing room at the bottom of this scrollable div
  padding-bottom: 32px;
  margin-bottom: -32px; // Prevent this from affecting anything outside the component

  & > * {
    opacity: 1;
    width: auto;
    transition: opacity 0.11s ease-in-out;

    margin-right: ${Spacing.SINGLE};
    ${Mixins.Media.minWidthSmall(`
      margin-right: ${Spacing.SINGLE_HALF};
    `)}

    box-shadow: 10px 16px 30px rgba(0, 0, 0, 0.1);
  }
  .offscreen {
    opacity: 0;
  }

  & > :first-child {
    margin-left: ${PADDING}px;
    ${Mixins.Media.minWidthMedium(`
      margin-left: ${SHADOW_BREATHING_ROOM}px;
    `)}
  }
  & > :last-child {
    margin-right: ${PADDING}px;
    ${Mixins.Media.minWidthMedium(`
      margin-right: ${SHADOW_BREATHING_ROOM}px;
    `)}
  }
`;

export const SegmentDivider = styled(DishFirstSegmentDivider)``;

export const SegmentDividerContainer = styled(DishFirstSegmentDividerContainer)`
  bottom: -20px;
`;
